/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 自定义 iconfont 图标组件
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-08-14 19:40:23
 */
import { createFromIconfontCN } from '@ant-design/icons'

export const TodayIconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_2048260_lss9dor7nxl.js'
})
